import Sidebar from './Sidebar';
import { COMPLETED } from '../../../../store/actions/types';
import { selectBrokerProduct, selectBrokerProducts } from '../../../../store/selectors/brokerProducts';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserInfo } from '../../../../store/selectors/userInfo';
import { getProduct } from '../../../../store/actions/brokerProducts';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

const IntegrationWrapper = ({ children }) => {
  const history = useHistory();
  const brokerProducts = useSelector(selectBrokerProducts);
  const brokerProduct = useSelector(selectBrokerProduct);
  const isBrokerProductsCompleted = brokerProducts.status === COMPLETED;
  const isBrokerProductCompleted = brokerProduct.status === COMPLETED;
  const dispatch = useDispatch();
  const { search } = useLocation();
  const {
    data: { recommendationCode },
  } = useSelector(selectUserInfo);

  const useQuery = () => new URLSearchParams(search);
  const query = useQuery();
  const product = query.get('product');

  const hasAllowedBrokerProduct = isBrokerProductsCompleted && brokerProducts?.data.find((item) => item.name === product);

  const getSelectedProductDetails = async () => {
    hasAllowedBrokerProduct ? dispatch(getProduct(product, recommendationCode)) : history.push('/404');
  };

  useEffect(() => {
    getSelectedProductDetails();
  }, []);

  return isBrokerProductCompleted && isBrokerProductsCompleted ? (
    <div className='integration__main--wrapper'>
      <Sidebar />

      {children}
    </div>
  ) : null;
};

export default IntegrationWrapper;
